<template>
    <!--================ start footer Area  =================-->
    	
    <div class="footer-area section_gap">
        <ul class="communities">
            <!-- <li><a href="https://www.facebook.com/Rich.Sunshine.Inn/" title="facebook" target="_blank">facebook</a></li>
            <li><a href="https://www.instagram.com/Rich.Sunshine.Inn/" title="Instagram" target="_blank">Instagram</a></li>
            <li><a href="line://ti/p/@bmj3918o" title="line" target="_blank">line</a></li>
            <li><a href="" title="youtube" target="_blank">youtube</a></li> -->
        </ul>
        <div class="container">
            <div class="row">
                <div class="col-lg-6  col-md-12 col-sm-12 mb-30">
                    <div class="single-footer-widget">
                        <h6 class="footer_title">See US</h6>
                        <p>954 台東縣卑南鄉富山村杉原70號</p>	
                        <p>位於台東最美麗海岸線-台11縣的山林間，擁有絕佳的地理位置與便利的旅遊網絡，距離台東市區只需15分鐘，附近即有富山護魚區、加路蘭遊憩區、水往上流及都蘭新東糖廠等景點。距離台東火車站僅需25分鐘車程。擁有面向東部兩個海灣-都蘭灣與杉原灣的遼闊海景、並且坐擁壯闊山脈的舒活海景民宿。</p>
                    </div>
                </div>
                <div class="col-lg-3  col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h6 class="footer_title text-left">About US</h6>
                        <ul>
                            <li>台東合法民宿編號 1360、1361 號</li>
                            <li>國民旅遊卡特約旅宿</li>
                            <li>現場可提供刷卡服務</li>
                        </ul>
                        <div class="footer-icon text-left">
                            <img :src="law" width="30" tag="合法民宿登記" title="合法民宿登記" />
                            <img :src="travel" width="30"  tag="國旅卡特約" title="國旅卡特約" />
                            <img :src="credit" width="60" tag="信用卡支付" title="信用卡支付" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h6 class="footer_title text-left">Contact US</h6>
                        <ul>
                            <li>入住時間 : 3pm - 9pm</li>
                            <li>退房時間 : 8am - 11am</li>
                            <li>管家服務 : open 8am - 10pm</li>
                            <li>訂房詢問客服 : open 10am - 8pm</li>
                            <li>Line ID : @bmj3918o</li>
                        </ul>
                    </div>
                </div>					
            </div>

            <div class="footer-bottom align-items-center">
                ⓒ 2020-2025 Rich-Sunshine Inn, Taitung. All RIGHTS RESERVED.
            </div>
        </div>
    </div>
    <!--================ End footer Area  =================-->
</template>

<script>
import lawed from '@/assets/lawGuestHouse.gif'
import travel from '@/assets/travelCard2.png'
import credit from '@/assets/creditCard.png'
export default {
  name: 'footers',
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    law () {
      return lawed
    },
    travel () {
      return travel
    },
    credit () {
      return credit
    }
  },
  mounted () {
    // console.log(this.$route.name)
  }
}
</script>

<style lang="scss" scoped>
    .footer-area {
        ul {
            padding-left: 0;
        }
        li {
            list-style: none;
            text-align: left;
        }
    }
    .communities {
        text-align: center;
        margin-bottom: 60px;
        li {
            display: inline-block;
            a {
                display: block;
                width: 28px;
                height: 28px;
                margin: 5px;
                // background-image: url(/img/communities_icon.svg);
                color: transparent;
                font-size: 0;
                background-size: 540%;
                background-color: #e6e6e6;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/FooterV2.vue